import { MMTrustLogos } from "../../global/MMTrustLogos";
import { HundredWashesSmallBlock } from "../hundred-washes-small-block";
import { ReturnPolicyBlock } from "../return-policy-block";

export const PDPTrustLogos = () => {
  return (
    <div className="flex flex-col gap-4 pb-4 mt-2 max-w-[416px] w-full">
      <div className="flex items-center justify-center gap-3 lg:gap-3.5 bg-surface-1 rounded-md p-4">
        <ReturnPolicyBlock />
        <HundredWashesSmallBlock />
      </div>
      <div className="flex items-center justify-center gap-4 flex-wrap [&_img]:h-5 [&_img]:w-auto [&>picture]:hidden">
        <MMTrustLogos maxLogos={4} />
      </div>
    </div>
  );
};
